// extracted by extract-css-chunks-webpack-plugin
module.exports = {"videoContainer":"_11Vtm","videoPlay":"_3Wc7x","loader":"_3b5jt","placeholder":"_3j_G1","containerHeight":"_3cslP"};